// Nothing transient goes into Turbo's page cache (phase 071; both page bundles call it).
//
// Turbo clones the page into its snapshot cache on `turbo:before-cache`, right
// before it leaves it, and a Back visit puts that clone on screen. A menu or a
// dialog that was open at that moment would come back open: `el-menu` mirrors
// its popover state into an `open` attribute and shows itself again when an
// element carrying it connects, and `el-dialog` calls `showModal()` for the
// same attribute. So both are closed first. A disclosure is left as it is —
// its open state is content the server may have rendered on purpose (a refused
// save comes back open), not chrome.
//
// `hidePopover()` and the attribute removal both run synchronously (the
// library answers `beforetoggle` and `attributeChangedCallback` in the same
// task), so the clone Turbo takes next sees them closed.
export function closeTransientElements(root: ParentNode = document): void {
  for (const menu of root.querySelectorAll<HTMLElement>("el-menu[popover], el-popover[popover]")) {
    if (menu.matches(":popover-open")) menu.hidePopover()
    menu.removeAttribute("open")
  }

  for (const dialog of root.querySelectorAll<HTMLElement>("el-dialog[open]")) {
    dialog.removeAttribute("open")
  }
  for (const dialog of root.querySelectorAll<HTMLDialogElement>("el-dialog dialog[open]")) {
    dialog.close()
  }
}
